import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 mt-10">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Left Column - Company Info */}
          <div>
            <h2 className="text-2xl font-bold text-white">Gases Dex</h2>
            <p className="mt-2 text-gray-400">
              Your one-stop center for high-quality gas equipment solutions.
            </p>

            <div className="mt-5">
              <h3 className="text-lg font-semibold text-white">Our Office</h3>
              <p className="text-gray-400">
                No. 9 Jalan PUJ 3/11, Puncak Jalil, <br />
                Bandar Baru Permai, 43300 Seri Kembangan, <br />
                Selangor, Malaysia
              </p>
            </div>

            <div className="mt-5">
              <h3 className="text-lg font-semibold text-white">
                Working Hours
              </h3>
              <p className="text-gray-400">
                Mon – Fri: 9 AM – 6 PM <br />
                Sat: 9 AM – 1 PM
              </p>
            </div>
          </div>

          {/* Right Column - Quick Links */}
          <div className="md:pl-12">
            <h3 className="text-xl font-semibold text-white">Quick Links</h3>
            <ul className="mt-3 space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-white transition">
                  Home
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/products" className="hover:text-white transition">
                  Products
                </a>
              </li>
              <li>
                <a href="/partners" className="hover:text-white transition">
                  Partners
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-10 text-center text-sm border-t border-gray-700 pt-4">
          © {new Date().getFullYear()} Gases Dex. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
